import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const PlusIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M8.75 7.25V0h-1.5v7.25H0v1.5h7.25V16h1.5V8.75H16v-1.5H8.75Z" />
  </IconWrapper>
)

export default PlusIconSmall
